export default __webpack_public_path__ + "static/media/start.04a30f1c.png";